import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Typography
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Icon, PrimaryButton, SecondaryButton } from "@prestosports/commons-ui";
import { PlayInsertionType } from "@prestosports/prestostats-core/Football";
import Restart32 from "@carbon/icons-react/lib/restart/32";
import Save32 from "@carbon/icons-react/lib/save/32";
import Close32 from "@carbon/icons-react/lib/close/32";
import { useAppContext } from "../../../../state/app/context";
import { useFootballContext } from "../../../../state/football-play/context";
import SubmitCancelListener from "../listeners/SubmitCancelListener";

const useStyles = makeStyles(() => ({
	root: {
		padding: "20px 0"
	}
}));

const StepHeader = ({
	title,
	subtitle,
	showRestart = true,
	showHeader = true,
	additionalActions = []
}) => {
	const classes = useStyles();
	const { state, startOver, toggleEditPlayMode, saveEditPlay } =
		useFootballContext();
	const currentPlay = state.currentPlay();
	const { state: appState, setConfirmSave } = useAppContext();
	const editPlay = appState.editPlay();
	const confirmSave = appState.confirmSave();
	const isSubmitting = appState.isSubmitting();
	const insertPlay = appState.insertPlay();
	const insertType = appState.insertType();
	const isReplacementInsert =
		!!insertPlay && insertType === PlayInsertionType.Replace;

	const handleClose = () => {
		setConfirmSave(false);
	};

	const handleSave = () => {
		saveEditPlay(null);
	};

	const editMode =
		!!editPlay && !!currentPlay && editPlay?.id === currentPlay?.id;

	const handleRestart = () => {
		if (!isSubmitting) startOver();
	};

	const handleOnSubmit = () => {
		if (editMode) {
			if (confirmSave) handleSave();
			else setConfirmSave(true);
		}
	};
	const handleOnCancel = () => {
		if (editMode) {
			if (confirmSave) handleClose();
			else toggleEditPlayMode(null);
		} else handleRestart();
	};

	return (
		<Grid
			container
			justifyContent="space-between"
			alignItems="center"
			className={classes.root}
		>
			{showHeader && (
				<div>
					<Typography variant="h5">{title}</Typography>
					<Typography variant="subtitle1">{subtitle}</Typography>
				</div>
			)}
			<>
				{showRestart && !editMode && !isReplacementInsert && (
					<div>
						<SecondaryButton
							id="button-restart"
							size="medium"
							label="Restart"
							variant="contained"
							startIcon={
								<Icon>
									<Restart32 />
								</Icon>
							}
							onClick={handleRestart}
						/>
					</div>
				)}
				{editMode && (
					<div>
						<Grid container direction="row" spacing={2}>
							<Grid item>
								<SecondaryButton
									id="button-cancel"
									size="medium"
									label="Cancel"
									variant="contained"
									startIcon={
										<Icon>
											<Close32 />
										</Icon>
									}
									onClick={() => toggleEditPlayMode(null)}
								/>
							</Grid>
							<Grid item>
								<PrimaryButton
									disabled={editPlay?.disabled}
									id="button-save"
									size="medium"
									label="Save"
									variant="contained"
									startIcon={
										<Icon>
											<Save32 />
										</Icon>
									}
									onClick={() => setConfirmSave(true)}
								/>
							</Grid>
						</Grid>
					</div>
				)}
				{(showRestart || editMode) && (
					<SubmitCancelListener
						submitDisabled={!editMode}
						onSubmit={handleOnSubmit}
						onCancel={handleOnCancel}
					/>
				)}
			</>

			{!!additionalActions.length && (
				<Grid container direction="row" spacing={2} justifyContent="flex-end">
					{additionalActions.map((a) => (
						<Grid item>
							<SecondaryButton
								id={a.name}
								size="medium"
								label={a.displayName}
								variant="contained"
								onClick={a.onSelect}
							/>
						</Grid>
					))}
				</Grid>
			)}

			<Dialog
				open={confirmSave}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onClose={handleClose}
			>
				<DialogTitle id="alert-dialog-title">Save play?</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Are you sure you want to save this play?
					</DialogContentText>
					<Typography variant="h5">{editPlay?.title}</Typography>
					<Typography variant="subtitle1">
						{editPlay?.messages?.join(" ")}
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="secondary">
						No
					</Button>
					<Button disabled={isSubmitting} onClick={handleSave} color="primary">
						Yes
					</Button>
				</DialogActions>
			</Dialog>
		</Grid>
	);
};

export default StepHeader;
